import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/skip';
import 'rxjs/add/operator/takeUntil';
import { Injectable } from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import * as log from '../actions/log';
import * as auth from '../actions/authentication';
import {ErrorLogService} from '../services/error-log';
import { ErrorModel } from '../models/error-model';

@Injectable()
export class LogEffects {

  @Effect()
  loadLogPage$: Observable<Action> = this.actions$
    .ofType(log.LOAD_LOG_PAGE)
    .map((action: log.LoadLogPageAction) => action.payload)
    .switchMap(pm => {

      const nextLookup$ = this.actions$.ofType(log.LOAD_LOG_PAGE).skip(1);
      const errorMessage = 'Error loading logs.';
      return this.logService.getPagedLogs(pm)
        .takeUntil(nextLookup$)
        .map(p => new log.LoadLogPageCompleteAction(p))
        .catch(e => of(new auth.ErrorAction(new ErrorModel(e, errorMessage))));
    });

  constructor(private actions$: Actions, private logService: ErrorLogService) {}
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/effects/log.ts